import { CMSResource } from "app/resources/cmsresource";
import { DepartmentScheduleResponse } from "./DepartmentScheduleResponse";

export class DepartmentScheduleListResponse extends CMSResource{
    calendarSchedule: Array<DepartmentScheduleResponse>;
    errorDays: Array<string>;
}